export default "__VITE_ASSET__1ca4157d__"